import FormControlLabelCore from '@mui/material/FormControlLabel';
import React, { useEffect, useState } from 'react';
import tw, { css } from 'twin.macro';
import { isObject } from 'utils/helper';

const cssFormControlLabel = css`
	${tw`my-05 ml-0 text-grey-7`};
`;

export default function FormControlLabel({ control, ...props }) {
	const [errorText, setErrorText] = useState(null);
	const { errors, required, name, onChange } = control.props;

	useEffect(() => {
		if(isObject(errors)) {
			setErrorText(errors[name]);
		}
	}, [errors]);

	const handleChange = event => {
		if(required && !event.target.checked) {
			setErrorText(errors[name]);
		} else {
			setErrorText(null);
		}
		onChange(event);
	};

	return (
		<>
			<FormControlLabelCore
				css={[ cssFormControlLabel ]}
				control={{ ...control, props: { ...control.props, errorText, onChange: handleChange }}}
				{...props}
			/>
			<p className='text-09 text-error'>{errorText}</p>
		</>
	);
}
